import React from "react";
import { Card } from "react-bootstrap";

import SupportEmailLink from "components/SupportEmailLink";
import IconMessageCard from "components/IconMessageCard";
import { FiAlertTriangle } from "react-icons/fi";

const IndividualDenied = (): React.JSX.Element => {
  window.analytics.page("Individual Denied");
  return (
    <Card style={{ paddingLeft: 50, paddingRight: 50 }}>
      <IconMessageCard
        header={"Application Denied"}
        subheader={
          <>
            <p>
              We&apos;re sorry, but we weren&apos;t able to approve your Icon
              application.
            </p>
            <p>
              If you believe this decision was made in error or have questions
              about your application, please reach out to us at{" "}
              <SupportEmailLink />.
            </p>

            <p>
              Thank you for your interest in Icon. We appreciate you considering
              us.
            </p>
          </>
        }
        icon={<FiAlertTriangle color="white" stroke="#60A4BF" size={16} />}
      />
    </Card>
  );
};
export default IndividualDenied;
